// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"616":"e08602ff","774":"f740a5fb","960":"e08602ff"}[chunkId] + ".css";
};